import axios from "axios";

const API = axios.create({
  baseURL: "https://api-envy.adcm.co.th/",
});

export default API;